
import axios from 'axios';


class NewsService{

    async getNews(lang){
        const response = await axios.get("https://partner.mbk777.com/api/news/" + lang);
        return response.data;
    }
}

export const newsService = new NewsService();